export { LastUserInfoComponent } from './last-user.component'



// WEBPACK FOOTER //
// ./src/app/shared/user/last-user/index.ts